export type TrendPoint={t:string;value:number|null;smoothed?:number};

const backendCopy:Record<string,string>={
  'Incomplete wearable data; readiness is capped at AMBER.':'Chybí data z hodinek, proto je dnes vhodný lehčí režim.',
  'Rest or recovery only; reassess symptoms.':'Dnes odpočívej nebo zvol jen lehkou regeneraci. Příznaky znovu zhodnoť před dalším tréninkem.',
  'Prioritize a full sleep opportunity.':'Dnes dej přednost plnohodnotnému spánku.',
  '-20% working sets, no intervals':'Uber přibližně pětinu pracovních sérií a vynech intervaly.',
  'Protect tonight’s sleep window.':'Dnes dej přednost plnohodnotnému spánku.',
  'Complete the planned session.':'Dokonči naplánovaný trénink.',
  'Signals are within personal baseline.':'Dnešní hodnoty odpovídají tvému obvyklému stavu.',
  'low subjective energy':'Nízká energie v dnešním hodnocení.',
  'high subjective stress':'Vysoký stres v dnešním hodnocení.',
  'illness reported':'Nahlášené příznaky nemoci.',
  'pain reported':'Nahlášená bolest.',
  'Log meals to calculate remaining targets.':'Zapiš dnešní jídla, aby šlo spočítat, co ještě zbývá.',
  'missing weight day':'Chybí alespoň jedno vážení za posledních 7 dní.',
  'Conservative four-week starter block pending equipment and health-profile confirmation.':'Úvodní čtyřtýdenní plán čeká na potvrzení vybavení a zdravotního stavu.',
  'DATA_INSUFFICIENT: fewer than 14 weight days.':'Pro úpravu cíle je potřeba alespoň 14 dní s vážením.',
  'No change: data quality below 70% logging completeness.':'Cíl se nemění, protože je zapsáno méně než 70 % potřebných dat.',
  'noise_dismissed: travel or illness within 7 days.':'Cíl se nemění, protože poslední týden ovlivnila cesta nebo nemoc.',
  'noise_dismissed: isolated single-day weight spike.':'Cíl se nemění, protože jednorázový výkyv hmotnosti není spolehlivý trend.',
  'No change: observed loss rate is on target with good data quality.':'Tempo hubnutí odpovídá cíli. Není potřeba nic měnit.',
  'No change: flat weight and waist are consistent with maintenance; data quality is high.':'Hmotnost i pas jsou stabilní a odpovídají udržovacímu cíli.',
  'No material trend warrants a target change.':'Data zatím neukazují trend, který by vyžadoval změnu cíle.',
  'Observed movement is within measurement noise.':'Změna je v mezích běžné odchylky měření.',
  'Sustained trend exceeds expected noise.':'Dlouhodobý trend je větší než běžná odchylka měření.',
  'No reliable signal.':'Data zatím neukazují spolehlivou změnu.',
  'Quarterly phase review is due.':'Je čas zkontrolovat nastavení další fáze plánu.',
  'User corrected erroneous measurement':'Oprava chybně zadaného měření.',
  'User recorded a new InBody result.':'Bylo zapsáno nové InBody měření.',
  'Synthetic demo baseline':'Výchozí hodnoty ukázkového profilu.',
  'Demo review found a sustained trend.':'Ukázková data ukazují dlouhodobý trend.',
  'Hit protein target on 4 office days':'Splň cíl bílkovin ve 4 pracovních dnech',
  'Complete 2 Zone 2 sessions':'Dokonči 2 lehké vytrvalostní tréninky',
  'Meet sleep target on 4 nights':'Splň spánkový cíl ve 4 nocích',
  'Keep normal targets; prioritize protein and hydration.':'Cíle zůstávají stejné. Pohlídej bílkoviny a pitný režim.',
};

const technicalLabels:Record<string,string>={
  starter_training_package:'Úvodní tréninkový plán',
  calorie_target_change:'Úprava kalorického cíle',
  plan_adjustment:'Úprava tréninkového plánu',
  initial_targets:'Výchozí cíle',
  inbody_measurement_recorded:'Nové InBody měření',
  volume_change:'Úprava objemu tréninku',
  deload_trigger:'Návrh odlehčovacího týdne',
  phase_change:'Změna fáze plánu',
  goal_recalibration:'Přepočet cíle',
  no_change:'Beze změny',
  workout_move:'Přesun tréninku',
};

const healthLabels:Record<string,string>={pain:'Bolest',injury:'Zranění',mobility_limit:'Omezení pohybu',condition:'Zdravotní stav',medication:'Léky',contraindication:'Kontraindikace'};

export function localizeBackendText(value:string|null|undefined){
  if(!value)return '';
  const hrv=value.match(/^HRV ([+-]?\d+(?:\.\d+)?)% vs baseline$/);
  if(hrv)return `HRV je o ${hrv[1]} % oproti obvyklé hodnotě.`;
  const heartRate=value.match(/^resting HR \+?(\d+(?:\.\d+)?) vs baseline$/);
  if(heartRate)return `Klidový tep je o ${heartRate[1]} úderů vyšší než obvykle.`;
  const sleep=value.match(/^sleep ([+-]?\d+(?:\.\d+)?) min vs baseline$/);
  if(sleep)return `Spánek je o ${sleep[1]} minut oproti obvyklé délce.`;
  const adjustment=value.match(/^Adaptive TDEE adjustment ([+-]?\d+) kcal after sustained trend\.$/);
  if(adjustment)return `Dlouhodobý trend navrhuje upravit denní cíl o ${adjustment[1]} kcal.`;
  if(value.startsWith('E2E '))return 'Testovací návrh vytvořený pro kontrolu aplikace.';
  return backendCopy[value]??value;
}

export function technicalLabel(value:string){
  return technicalLabels[value]??'Návrh ke schválení';
}

export function healthLabel(value:string|null|undefined){return value?healthLabels[value]??value:'';}

export function nonNullPoints(points:TrendPoint[]){return points.filter((point):point is TrendPoint&{value:number}=>point.value!==null);}

export function trendSummary(points:TrendPoint[]){
  const valid=nonNullPoints(points),first=valid[0],last=valid.at(-1);
  if(!first||!last)return null;
  const delta=last.value-first.value;
  return {first:first.value,last:last.value,delta,from:first.t,to:last.t};
}
